<template>
  <div>
    <div id="root">
        <div class="pc_platform_container" :class="isAmuseTheme ? 'amuseContainer':''">
          <div id="js-lv_header" class="Lv_Header-wrapper fixed">
            <div style="display: flex;align-items: center">
              <img :src="logo" alt="" class="logo" >
              <div class="menu-bar">
                <div v-for="(x,key) in tabMenu" :key="key" class="tabName"
                     :href="x.id"
                     @click="changeTab(key)"
                     :class="key == curTab ? 'active' : ''">
                  {{x.label}}
                </div>
                <div class="line"></div>
              </div>
            </div>
            <div class="action-bar">
              <div class="language" @mouseover="showHideMenu = true">
                <img src="../../assets/word.svg" alt="" class="languageIcon">
                <img src="../../assets/arrowDown.svg" alt="" class="arrowIcon">

                <div class="hideMenu" v-if="showHideMenu" @mouseleave="showHideMenu = false">
                <span v-for="x in langList"
                      :class="langKey == x.value ? 'active' : ''"
                      @click="changeLanguage(x)">{{x.label}}</span>
                </div>
              </div>
              <div class="downloadBtn" @click="showPopModalFunc">
                {{langConfig.appDownload[langKey]}}
              </div>
            </div>
          </div>
          <template v-if="!isAmuseTheme">
            <div class="pc-Landing-wrapper" >
              <div class="pc-main-feature-wrapper" id="index">
                <img src="../../assets/1.png" alt="" class="video">
                <div class="container">
                  <h1 class="title">
                    <span>{{langConfig.multiTrade[langKey]}}</span>
                    &nbsp;&nbsp;<span>{{langConfig.multiIncome[langKey]}}</span>
                  </h1>

                  <h2 class="subtitle">{{langConfig.topPlatForm[langKey]}}</h2>
                  <button @click="showPopModalFunc" class="btn" type="button">
                    <span>{{langConfig.createAccount[langKey]}}</span>
                  </button>

                  <div class="three w1100" :class="'l' + langKey">
                    <div class="d1">
                      <div style="display: flex;align-items: center;">
                        <img src="../../assets/security.png" alt="" style="width : 26px;height : 30px">
                        <p class="ptxt">{{langConfig.security[langKey]}}</p>
                      </div>

                      <p class="pContent">{{langConfig.risk[langKey]}}</p>
                    </div>
                    <div class="d2">
                      <div style="display: flex;align-items: center;">
                        <img src="../../assets/fastCharge.png" alt="" style="width : 30px;height : 22px;">

                        <p class="ptxt">{{langConfig.a[langKey]}}</p>
                      </div>

                      <p class="pContent">{{langConfig.b[langKey]}}</p>
                    </div>
                    <div class="d3">
                      <div style="display: flex;align-items: center;">
                        <img src="../../assets/global.png" alt="" style="width : 32px;height : 28px">

                        <p class="ptxt">{{langConfig.c[langKey]}}</p>
                      </div>

                      <p class="pContent">{{langConfig.d[langKey]}}</p>
                    </div>
                  </div>

                </div>


                <div class="view-more">
                  <span>{{langConfig.e[langKey]}}</span>
                  <div class="view-more-arrow view-more-arrow-0"></div>
                  <div class="view-more-arrow view-more-arrow-1"></div>
                  <div class="view-more-arrow view-more-arrow-2"></div>
                </div>
              </div>
              <div class="pc-action-guidance-wrapper exchangeAndSwap">
                <!--现货-->
                <div class="editor" id="exchange">
                  <div class="description">
                    <h2 class="title Landing-features-title">
                      {{langConfig.q[langKey]}}<span style="background:linear-gradient(to right, #4FA1EC, #6FFAEF);-webkit-background-clip:text;-webkit-text-fill-color:transparent">{{langConfig.f[langKey]}}</span>
                    </h2>
                    <h3 class="subtitle" style="text-align: left">{{langConfig.g[langKey]}}</h3>
                    <button class="btn" type="button" @click="showPopModalFunc">
                      <span>{{langConfig.createAccount[langKey]}}</span>
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFdSURBVHgB1ZfbUcMwEEWvHv53CS6BElICVABUAFTgpAK7g6SD0AHpgHQQd+ACEmtZDX8gBZJMdpUzY3ts/dxZn1mtDC7FuScQNYnv79jvtxDH+5lxjhLXyKsNVPB+ngxl7Se04AAfqVDW+w5K1FyRXSoU+3QPFarqrjyfrH094lMNDTjA+nZ84gpChW+fxtvwybkdtHziptknfXJuCSUK9ImdyfhE0TWowFPBf3zycbdGCDNcG6J4H2BM82MlVm9J0/QQXwz/x7kxpoUyRPTGhek9CoGL0pH322ICcYkGTNNgUQhk7TM/Bs8ObSgESJBzlYxZ4HDYQBJrbZsZ3tYQJ9eDuINDYaONfSa9dQDyXTobhk8qkIa96TLeyO/0HOalNG/GjDcNhKmz3lSV/PzDk+AqI3EPaf7wRnyGbjJhVE4Z+ebn3COkKc2b9og3J3PxgBbiGEy0+L0QVjiDL12f5EDIsePwAAAAAElFTkSuQmCC" class="union-icon"/>
                    </button>
                  </div>
                  <div class="cover" style="vertical-align: middle">
                    <img src="../../assets/exchange.png" style="margin-left: 100px;background-size: contain;background-repeat: no-repeat;background-position: center center;height: 72%;" alt="">
                  </div>
                </div>
                <!--合约-->
                <div class="cooperation" id="swap">
                  <div class="cover">
                    <img src="../../assets/heyue1.png" style="background-size: contain;background-repeat: no-repeat;background-position: center center;height: 72%;" alt="">
                    <img src="../../assets/heyue2.png" style="margin-right: 30px;background-size: contain;background-repeat: no-repeat;background-position: center center;height: 72%;" alt="">
                  </div>
                  <div class="description">
                    <h2 class="title Landing-features-title">
                      {{langConfig.r[langKey]}}<span style="text-align:left;background:linear-gradient(to right, #4FA1EC, #6FFAEF);-webkit-background-clip:text;-webkit-text-fill-color:transparent"> {{langConfig.h[langKey]}}</span>
                    </h2>
                    <h3 class="subtitle" style="text-align: left">{{langConfig.i[langKey]}}</h3>
                    <button @click="showPopModalFunc" class="btn" type="button">
                      <span>{{langConfig.createAccount[langKey]}}</span>
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFdSURBVHgB1ZfbUcMwEEWvHv53CS6BElICVABUAFTgpAK7g6SD0AHpgHQQd+ACEmtZDX8gBZJMdpUzY3ts/dxZn1mtDC7FuScQNYnv79jvtxDH+5lxjhLXyKsNVPB+ngxl7Se04AAfqVDW+w5K1FyRXSoU+3QPFarqrjyfrH094lMNDTjA+nZ84gpChW+fxtvwybkdtHziptknfXJuCSUK9ImdyfhE0TWowFPBf3zycbdGCDNcG6J4H2BM82MlVm9J0/QQXwz/x7kxpoUyRPTGhek9CoGL0pH322ICcYkGTNNgUQhk7TM/Bs8ObSgESJBzlYxZ4HDYQBJrbZsZ3tYQJ9eDuINDYaONfSa9dQDyXTobhk8qkIa96TLeyO/0HOalNG/GjDcNhKmz3lSV/PzDk+AqI3EPaf7wRnyGbjJhVE4Z+ebn3COkKc2b9og3J3PxgBbiGEy0+L0QVjiDL12f5EDIsePwAAAAAElFTkSuQmCC" class="union-icon"/>
                    </button>
                  </div>
                </div>
              </div>

              <!--期权-->
              <div class="pc-action-guidance-wrapper option" id="option">
                <div class="editor">
                  <div class="description">
                    <h2 class="title Landing-features-title">
                      {{langConfig.s[langKey]}}/{{langConfig.vv[langKey]}}
                      <span style="text-align:left;background:linear-gradient(to right, #4FA1EC, #6FFAEF);-webkit-background-clip:text;-webkit-text-fill-color:transparent">{{langConfig.j[langKey]}}</span>
                    </h2>
                    <h3 class="subtitle"  style="text-align: left">{{langConfig.k[langKey]}}</h3>
                    <button @click="showPopModalFunc" class="btn" type="button">
                      <span>{{langConfig.createAccount[langKey]}}</span>
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFdSURBVHgB1ZfbUcMwEEWvHv53CS6BElICVABUAFTgpAK7g6SD0AHpgHQQd+ACEmtZDX8gBZJMdpUzY3ts/dxZn1mtDC7FuScQNYnv79jvtxDH+5lxjhLXyKsNVPB+ngxl7Se04AAfqVDW+w5K1FyRXSoU+3QPFarqrjyfrH094lMNDTjA+nZ84gpChW+fxtvwybkdtHziptknfXJuCSUK9ImdyfhE0TWowFPBf3zycbdGCDNcG6J4H2BM82MlVm9J0/QQXwz/x7kxpoUyRPTGhek9CoGL0pH322ICcYkGTNNgUQhk7TM/Bs8ObSgESJBzlYxZ4HDYQBJrbZsZ3tYQJ9eDuINDYaONfSa9dQDyXTobhk8qkIa96TLeyO/0HOalNG/GjDcNhKmz3lSV/PzDk+AqI3EPaf7wRnyGbjJhVE4Z+ebn3COkKc2b9og3J3PxgBbiGEy0+L0QVjiDL12f5EDIsePwAAAAAElFTkSuQmCC" class="union-icon"/>
                    </button>
                  </div>
                  <div class="cover">
                    <img src="../../assets/qiquan2.png" style="background-size: contain;background-repeat: no-repeat;background-position: center center;height: 72%;margin-right: 30px" alt="">
                    <img src="../../assets/qiquan1.png" style="background-size: contain;background-repeat: no-repeat;background-position: center center;height: 72%;" alt="">
                  </div>
                </div>
              </div>

              <!--游戏-->
              <div class="pc-scene-introduction-wrapper" id="game">
                <div class="editor">
                  <div class="description">
                    <h2 class="title Landing-features-title">
                      {{langConfig.u[langKey]}}
                      <br/>
                      <span style="text-align:left;background:linear-gradient(to right, #4FA1EC, #6FFAEF);-webkit-background-clip:text;-webkit-text-fill-color:transparent">{{langConfig.l[langKey]}}</span>
                    </h2>
                    <h3 class="subtitle" style="text-align: center;">{{langConfig.m[langKey]}}</h3>
                    <button @click="showPopModalFunc" style="margin: 0 auto" class="btn" type="button">
                      <span>{{langConfig.createAccount[langKey]}}</span>
                      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFdSURBVHgB1ZfbUcMwEEWvHv53CS6BElICVABUAFTgpAK7g6SD0AHpgHQQd+ACEmtZDX8gBZJMdpUzY3ts/dxZn1mtDC7FuScQNYnv79jvtxDH+5lxjhLXyKsNVPB+ngxl7Se04AAfqVDW+w5K1FyRXSoU+3QPFarqrjyfrH094lMNDTjA+nZ84gpChW+fxtvwybkdtHziptknfXJuCSUK9ImdyfhE0TWowFPBf3zycbdGCDNcG6J4H2BM82MlVm9J0/QQXwz/x7kxpoUyRPTGhek9CoGL0pH322ICcYkGTNNgUQhk7TM/Bs8ObSgESJBzlYxZ4HDYQBJrbZsZ3tYQJ9eDuINDYaONfSa9dQDyXTobhk8qkIa96TLeyO/0HOalNG/GjDcNhKmz3lSV/PzDk+AqI3EPaf7wRnyGbjJhVE4Z+ebn3COkKc2b9og3J3PxgBbiGEy0+L0QVjiDL12f5EDIsePwAAAAAElFTkSuQmCC" class="union-icon"/>
                    </button>
                  </div>
                </div>

                <div class="content">
                  <img class="cover" src="../../assets/game1.png" style="margin-right: 30px;background-size: contain;background-repeat: no-repeat;background-position: center center;" alt="社交媒体"/>
                  <img class="cover" src="../../assets/game2.png" style="background-size: contain;background-repeat: no-repeat;background-position: center center;" alt="广告大片"/>
                  <img class="cover" src="../../assets/game3.png" style="margin: 0 30px;background-size: contain;background-repeat: no-repeat;background-position: center center;" alt="知识分享"/>
                  <img class="cover" src="../../assets/game4.png" style="background-size: contain;background-repeat: no-repeat;background-position: center center;" alt="电商种草"/>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="centerBox">
              <div class="pc-Landing-wrapper" >
                <div class="pc-main-feature-wrapper" id="index">
                  <div class="container">
                    <h1 class="title">
                      <span class="yishuzi">{{$t('version25.t1')}}</span>
                    </h1>

                    <h2 class="subtitle" :class="lang">{{$t('version25.t2')}}</h2>
                    <div @click="showPopModalFunc" class="newBtn" type="button">
                      <span>{{langConfig.createAccount[langKey]}}</span>
                    </div>

                    <div class="threeBox" :class="'l' + langKey">
                      <div class="d1">
                        <p class="ptxt">{{langConfig.security[langKey]}}</p>
                        <p class="pContent">{{langConfig.risk[langKey]}}</p>
                      </div>
                      <div class="d2">
                        <p class="ptxt">{{langConfig.a[langKey]}}</p>
                        <p class="pContent">{{langConfig.b[langKey]}}</p>
                      </div>
                      <div class="d3">
                        <p class="ptxt">{{langConfig.c[langKey]}}</p>
                        <p class="pContent">{{langConfig.d[langKey]}}</p>
                      </div>
                    </div>

                  </div>


                  <div class="view-more">
                    <span>{{langConfig.e[langKey]}}</span>
                    <div class="view-more-arrow view-more-arrow-0"></div>
                    <div class="view-more-arrow view-more-arrow-1"></div>
                    <div class="view-more-arrow view-more-arrow-2"></div>
                  </div>
                </div>
                <div class="pc-action-guidance-wrapper exchangeAndSwap" id="exchangeAndSwap">
                  <!--现货-->
                  <div class="editor" id="ourGame">
                    <div class="description">
                      <h2 class="title Landing-features-title yishuzi" :class="lang">{{$t('version25.ourGame')}}
                      </h2>
                      <h3 class="subtitle" style="text-align: left">{{langConfig.l[langKey]}}</h3>
                      <div class="newBtn" type="button" @click="showPopModalFunc">
                        <span>{{langConfig.createAccount[langKey]}}</span>
                      </div>
                    </div>
                    <!-- Swiper -->
                    <div class="swiper-container" @click="showPopModalFunc" :style="{opacity:isShowSwiper ? 1 : 0}">
                      <div class="swiper-wrapper">
<!--                          <div class="swiper-slide">-->
                            <img src="../../assets/block.png?v=2" alt="" class="swiper-slide">
                         <!-- </div>
                          <div class="swiper-slide">-->
                            <img src="../../assets/Discs.png?v=2" alt="" class="swiper-slide">
                          <!--</div>
                          <div class="swiper-slide">-->
                            <img src="../../assets/LOTTO.png?v=2" alt="" class="swiper-slide">
                          <!--</div>
                          <div class="swiper-slide">-->
<!--                            <img src="../../assets/Luck1U.png?v=2" alt="" class="swiper-slide">-->
                          <!--</div>
                          <div class="swiper-slide">-->
                            <img src="../../assets/Lucky28.png?v=2" alt="" class="swiper-slide">
                          <!--</div>
                          <div class="swiper-slide">-->
                            <img src="../../assets/Random100.png?v=2" alt="" class="swiper-slide">
                          <!--</div>
                          <div class="swiper-slide">-->
                            <img src="../../assets/Roulette.png?v=2" alt="" class="swiper-slide">
                          <!--</div>
                          <div class="swiper-slide">-->
                            <img src="../../assets/FT.png?v=2" alt="" class="swiper-slide">
                            <img src="../../assets/Crash.png?v=2" alt="" class="swiper-slide">
                            <img src="../../assets/HILO.png?v=2" alt="" class="swiper-slide">
                            <img src="../../assets/limbo.png?v=2" alt="" class="swiper-slide">
                            <img src="../../assets/KENO.png?v=2" alt="" class="swiper-slide">
                            <img src="../../assets/MinesWeeping.png?v=2" alt="" class="swiper-slide">
                            <img src="../../assets/Red_Green.png?v=2" alt="" class="swiper-slide">
                            <img src="../../assets/SICBO.png?v=2" alt="" class="swiper-slide">
                            <img src="../../assets/FSLOT.png?v=2" alt="" class="swiper-slide">
                            <img src="../../assets/WHEEL@2x.png?v=2" alt="" class="swiper-slide">
                            <img src="../../assets/Red_Black@2x.png?v=2" alt="" class="swiper-slide">
<!--                          </div>-->
                      </div>
                      <!-- Add Pagination -->
<!--                      <div class="swiper-pagination"></div>-->
                    </div>
                  </div>
                  <!--合约-->
                  <div class="cooperation" id="electron">
                    <img  class="electronPig" src="../../assets/PIG002.png"  alt="">

                    <div class="innerBox">
                      <h2 class="title Landing-features-title yishuzi">
                        {{$t('version25.electron_index')}}
                      </h2>
                       <!--<h3 class="subtitle">Powered by Evolution</h3>-->
                      <!-- <img src="../../assets/Evolution.png" alt="" class="smallLogo"> -->
                      <div @click="showPopModalFunc" class="newBtn" type="button">
                        <span>{{langConfig.createAccount[langKey]}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!--期权-->
                <div class="pc-action-guidance-wrapper" id="sport">
                  <div class="innerBox">
                    <h2 class="title Landing-features-title yishuzi">
                      {{$t('version25.sport_index')}}
                    </h2>
                    <!-- <h3 class="subtitle"  style="text-align: left">Powered by PM</h3> -->
                    <!-- <img src="../../assets/PM.png" alt="" class="smallLogo"> -->
                    <div @click="showPopModalFunc" class="newBtn">
                      <span>{{langConfig.createAccount[langKey]}}</span>
                    </div>
                  </div>
                  <div class="swiper-container2" @click="showPopModalFunc">
                    <div class="swiper-wrapper">

                      <img src="../../assets/Basketball.png" alt="" class="swiper-slide">

                      <img src="../../assets/Football.png" alt="" class="swiper-slide">

                      <img src="../../assets/Snooker.png" alt="" class="swiper-slide">
                      <img src="../../assets/Tennis.png" alt="" class="swiper-slide">

                      <img src="../../assets/TableTennis.png" alt="" class="swiper-slide">

                      <img src="../../assets/Volleyball.png" alt="" class="swiper-slide">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--游戏-->
            <div class="pc-scene-introduction-wrapper" id="live">
              <div class="editor">
                <div class="description">
                  <h2 class="title Landing-features-title yishuzi">
                    {{$t('version25.live_index')}}
                  </h2>
                  <!-- <h3 class="subtitle" style="text-align: center;">Powered by Ezugi</h3> -->
                  <!-- <img src="../../assets/Ezugi.png" alt="" class="img-icon"> -->
                </div>
              </div>

              <div class="content">
                <p>Live Casino</p>
                <div @click="showPopModalFunc" class="newBtn" type="button">
                  <span>{{langConfig.createAccount[langKey]}}</span>
                </div>
              </div>
            </div>
          </template>
          <div class="pc-footer-wrapper border">
            <div class="pc-footer-container">
              <div class="pc-footer-top">
                <div class="pc-footer-logo-container" style="text-align: left">
                  <img :src="logo" alt="" style="height: 36px;">
                  <p class="pc-footer-bottom-paragraph topPlatForm" style="text-align: left">
                    {{$t('version25.t2')}}

                  </p>
                  <p class="pc-footer-bottom-paragraph">
                    Copyright © 2016 - All rights reserved. v2.6.1
                  </p>
                  <p>
                    <span @click="showProxy('yszc')" style="color:#fff;margin-right: 15px;cursor: pointer;">{{langConfig.yszc[langKey]}}</span>
                    <span @click="showProxy('mzsm')" style="color:#fff;cursor: pointer">{{langConfig.mzsm[langKey]}}</span>
                  </p>
                  <button class="invite-btn" @click="go()">{{langConfig.backstage[langKey]}}</button>
                </div>
                <div class="pc-footer-link-group">
                  <div id="bottomCode" ref="qrCode"></div>
                  <p class="bottomTxt">{{langConfig.n[langKey]}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>



    <div class="popModal" v-if="showPopModal" :class="isAmuseTheme ? 'amusePop':''">
      <div class="mask"></div>
      <div class="popMain">
        <img src="../../assets/close.svg" alt="" class="closeBtn" @click="showPopModal=false">

        <div class="qrCode" id="qrCode"></div>
        <p class="site" v-html="langConfig.o[langKey].replace(/\{link\}/,site + (code ? `/reg?code=${code}` : ''))"></p>
      </div>
    </div>




<!--    隐私政策和免责声明-->
    <div class="popModal" v-if="showBtmModal">
      <div class="mask"></div>
      <div class="popMain_btm">
        <img src="../../assets/close.svg" alt="" class="closeBtn" @click="showBtmModal=false">
        <div class="title">{{showBtmModal == 'yszc' ? langConfig.yszc[langKey] : langConfig.mzsm[langKey]}}</div>
        <div class="popContent" v-html="popContent">

        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import {tenantinfo,getHelpDetail,getServiceList} from '@/request/api.js'
  import langData from '@/lang'
  import {state, mutations} from '@/store'
/*  import {Swiper,SwiperSlider} from 'swiper/vue'
  import 'swiper/css'*/
  const backEndMap = {
    "en-US": "en-US",
    "zh-TW": "zh-TW",
    "zh-CN": "zh-CN",
    ja: "ja",
    th: "tha",
    vi: "vi",
    es: "es-US",
    id: "idn",
    pt: "pt",
    tr: "tr",
  }
  const keyMap = {
    'zh-CN' : 0,
    'zh-TW' : 1,
    'en-US' : 2,
    'es' : 3,
    'es-US' : 3,
    'pt' : 4,
    'ja' : 5,
    'th' : 6,
    'tha' : 6,
    'vi' : 7,
    'id' : 8,
    'idn' : 8,
    'tr' : 9
  }
  let lang


  export default {
    name: 'Home-Page',
    props: {
      msg: String
    },
    data() {
      return {
        isShowSwiper : false,
        count: 0,
        langConfig : langData,
        lang : '',
        curTab : 0,
        showPopModal : false,
        isShowCustomer: false,
        customerServiceType: 3,
        customerServiceUrl: '',
        popupTxt: '',
       
        site : window.location.origin.replace(/www/,'m'),
        showHideMenu : false,
        langList : [],
        code: '',
        showBtmModal : false,
        popContent : null,
        serviceList : [],
        showServiceModal : false
      }
    },
    computed : {

      langDataList: () => state.langList,
      siteConfig: () => state.siteConfig,
      tabMenu(){
        return this.isAmuseTheme ?
                [{
                  label : this.langConfig.p[this.langKey],
                  id : '#index'
                },{
                  label : this.$t('version25.ourGame'),
                  id : '#ourGame'
                },{
                  label : this.$t('version25.electron_index'),
                  id : '#electron'
                },{
                  label : this.$t('version25.sport_index'),
                  id : '#sport'
                },{
                  label : this.$t('version25.live_index'),
                  id : '#live'
                }] : [{
          label : this.langConfig.p[this.langKey],
          id : '#index'
        },{
          label : this.langConfig.q[this.langKey],
          id : '#exchange'
        },{
          label : this.langConfig.r[this.langKey],
          id : '#swap'
        },{
          label : this.langConfig.qiquan[this.langKey],
          id : '#option'
        },{
          label : this.langConfig.u[this.langKey],
          id : '#game'
        }]
      },
      langKey(){
        let key = keyMap[this.lang] 
        if(key === null || key === undefined || key === '')
         key = keyMap[Object.keys(keyMap).find(item=>this.lang.startsWith(item))]
        return key
      },
      logo(){
        return state.siteConfig.mobileLogo && state.siteConfig.mobileLogo.startsWith('/') ? this.siteConfig.mobileLogo : '/' + this.siteConfig.mobileLogo
      },
      isAmuseTheme(){
        return [4,5,6].includes(this.siteConfig.mobileTheme)
      }
    },
   /* components:{
      Swiper,
      SwiperSlider
    },*/
    watch: {
      'siteConfig': {
        handler(newVal, oldVal) {
         /* if (newVal.webpageIco) {
            let link =
              document.querySelector("link[rel*='icon']") ||
              document.createElement("link");
            link.type = "image/x-icon";
            link.rel = "shortcut icon";
            link.href = newVal.webpageIco && newVal.webpageIco.startsWith('/') ? newVal.webpageIco : '/' + newVal.webpageIco;
            document.getElementsByTagName("head")?.[0]?.appendChild(link);
          }*/
        //  this.customerServiceType = newVal.customerServiceType;
        
          if (newVal.mobileTitle) document.title = newVal.mobileTitle;
        },
        immediate: true,
        deep: true
      },
      'langDataList': {
        handler(newVal, oldVal) {
          console.log(newVal, 'newVal')
          this.langList = newVal.map(item => {
            let __langKey = Object.values(backEndMap).find(key => key === item.code)
            return {
              label: item.label,
              code: __langKey,
              value: keyMap[__langKey]
            }
          });
          const lang = localStorage.getItem('lang');
          const index = this.langList.findIndex(item => {
            return item.code === lang
          })
          if (lang && !!~index) {
            this.lang = lang
          } else if (this.langList.length > 0) {
            this.lang = this.langList?.[0]?.code;
          } else {
            // 维护拿不到语言列表，默认取浏览器默认语言
            if (window.navigator.language in backEndMap) {
              this.lang = backEndMap[window.navigator.language]
            } else {
              this.lang = 'en-US'
            }
          }
          console.log(this.lang,'this.lang')
          this.$nextTick(() => {
            const line = document.querySelector('.line');
            const tabs = document.querySelectorAll('.tabName');
            line.style.left = (((tabs[0].getBoundingClientRect().width - 32) / 2)) + 'px';
          });

        },
        immediate: true,
        deep: true
      }
    },
    created() {
      this.code = this.$route?.query?.code || ''
    },
    mounted(){

      document.documentElement.scrollTop = 0;

      console.log(keyMap[Object.keys(keyMap).find(item=>this.lang.startsWith(item))])

    

     setTimeout(()=>{
        let qrCode = document.getElementById("bottomCode");
          if (qrCode) qrCode.innerHTML = "";
          this.qrCode = new QRCode("bottomCode", {
            text: this.site + (this.code ? `/reg?code=${this.code}` : ''),
            width: 90,
            height: 90,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.L,
          });
     },3000)


      setTimeout(() => {


        if(this.isAmuseTheme){
          var swiper = new Swiper('.swiper-container', {
            slidesPerView: '3',
            // spaceBetween: 30,
            centeredSlides: true,
            autoplay:true,
            loop: true,
            /*  pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },*/
          });

          this.isShowSwiper=true

          var swiper2 = new Swiper('.swiper-container2', {
            slidesPerView: '3',
            autoplay:true,
            // spaceBetween: 30,
            centeredSlides: true,
            direction : 'vertical',
            loop: true,
            /*  pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },*/
          });
        }

        if (this.code) this.showPopModalFunc()

        if(this.$route.query?.type){
          this.showProxy(this.$route.query.type == 1 ? 'yszc' : 'mzsm')
        }
        let exchangeDom,swapDom,optionDom,gameDom,exchangeTop,
        swapTop,optionTop,gameTop,exchangeAndSwap
        this.$nextTick(()=>{
           exchangeDom = this.isAmuseTheme ? document.querySelector('#ourGame') : document.querySelector('#exchange');
           swapDom = this.isAmuseTheme ? document.querySelector('#electron') :document.querySelector('#swap');
           optionDom = this.isAmuseTheme ? document.querySelector('#sport') :document.querySelector('#option');
           gameDom = this.isAmuseTheme ? document.querySelector('#live') :document.querySelector('#game');
           exchangeAndSwap = document.getElementById("exchangeAndSwap") 

           exchangeTop = exchangeDom.offsetTop - 64;
           swapTop = swapDom.offsetTop - 64;
           optionTop = optionDom.offsetTop - 64;
           gameTop = gameDom.offsetTop - 64;
        })

       

        console.log(exchangeTop,exchangeDom)

        window.addEventListener('scroll', () => {
          const scrollTop = document.documentElement.scrollTop
          // console.log(scrollTop,exchangeDom.offsetTop,'scroll')

          if (scrollTop >= 0 && scrollTop < exchangeTop) {

            this.curTab = 0
            this.lineScroll(0)
          } else if (scrollTop >= exchangeTop && scrollTop < swapTop) {

            this.curTab = 1
            this.lineScroll(1)
          } else if (scrollTop >= swapTop && scrollTop < optionTop) {

            this.curTab = 2
            this.lineScroll(2)
          } else if (scrollTop >= optionTop && scrollTop < gameTop) {

            this.curTab = 3
            this.lineScroll(3)
          } else {

            this.curTab = 4
            this.lineScroll(4)
          }
        })

      }, 1000)


    },
    methods : {
      showProxy(type){
        this.showBtmModal=type
        let id = type == 'yszc' ? '1561920999970881538' : '1561913413863260161'
        getHelpDetail({id : id}).then(res=>{
          if(res.code == 200){
              this.popContent = res.data && res.data.content || ''
          }
        })
        this.$router.push(`${this.$route.path}?type=${type == 'yszc' ? 1 : 2}`)
      },
      go() {
        window.open(window.location.origin + '/inviteCenter')
      },
      getOptions() {
        tenantinfo().then(res => {
          if (res.code === 200) {
            mutations.changeSiteConfig(res.data)
          }
        })
      },
  
      lineScroll(x) {
        const line = document.querySelector('.line');
        const tabs = document.querySelectorAll('.tabName');
        let len = 0;
        if (x === 0) {
          len = ((tabs[0].getBoundingClientRect().width - 32) / 2);
        } else {
          let offsetLeft = 0;
          const widthArr = [];
          for(let i = 0;i< tabs.length; i++) {
            widthArr.push(tabs[i].getBoundingClientRect().width);
          }
          for(let j = 0;j < x;j++) {
            offsetLeft += widthArr[j];
          }
          offsetLeft += ((tabs[x].getBoundingClientRect().width - 32) / 2);
          len = offsetLeft;
        }
        line.style.left = len + 'px';
      },
      showPopModalFunc(){
        this.showPopModal = true
        this.$nextTick(() => {
          let qrCode = document.getElementById("qrCode");
          if (qrCode) qrCode.innerHTML = "";
          this.qrCode = new QRCode("qrCode", {
            text: this.site + (this.code ? `/reg?code=${this.code}` : ''),
            width: 190,
            height: 190,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.L,
          });

        });
      },
      changeTab(x){
        if(this.curTab == x) return
        this.curTab = x

        const exchangeDom = this.isAmuseTheme ? document.querySelector('#ourGame') : document.querySelector('#exchange');
        const swapDom = this.isAmuseTheme ? document.querySelector('#electron') :document.querySelector('#swap');
        const optionDom = this.isAmuseTheme ? document.querySelector('#sport') :document.querySelector('#option');
        const gameDom = this.isAmuseTheme ? document.querySelector('#live') :document.querySelector('#game');

        let top = 0
        if (x === 1) {
          top = exchangeDom.offsetTop /* - 64 */;
        } else if (x ===2 ) {
          top = swapDom.offsetTop /* - 64 */;
        } else if (x === 3) {
          top = optionDom.offsetTop /* - 64 */;
        } else if (x === 4) {
          top = gameDom.offsetTop /* - 64 */;
        } else if (x === 0) {
          top = 0
        }
        this.scrollTo(top, 200)
      },
      changeLanguage(data){
        if(this.langKey == data.value) return
        this.lang = data.code;
        mutations.setLang(data.code, this)
        this.getOptions();

        let timer = setTimeout(() => {
          this.lineScroll(this.curTab);
          clearTimeout(timer);
        }, 50);


      },
      scrollTo(top, time) {
        if (!time) {
          document.body.scrollTop = document.documentElement.scrollTop = top;
          return top
        }
        const spacingTime = 20;
        let spacingNum = time / spacingTime;
        let nowTop = document.documentElement.scrollTop;
        let everTop = (top - nowTop) / spacingNum;
        let timer = setInterval(() => {
          if (spacingNum > 0) {
            spacingNum--;
            this.scrollTo(nowTop += everTop)
          } else {
            clearInterval(timer);
          }
        }, spacingTime);
      }
    },
  }
</script>

<style scoped lang="scss">
  @import "3.css";
  $maxWidth : 1000px;
  .amuseContainer{
    background: url("../../assets/bg.png") no-repeat center top;
    background-size: 100% 100%;
    .centerBox{
      width : $maxWidth;
     margin: 0 auto;
    }
    .pc-Landing-wrapper{
      background: none;
    }
    .Lv_Header-wrapper{
      background:#111822;
    }
    .newBtn{
      background: url("../../assets/btn_bg.png") no-repeat center center;
      background-size: 100% 100%;
      width : 166px;
      height : 50px;
      line-height: 50px;
      cursor: pointer;
      span{
        color:#fff;
      }
    }

    .yishuzi{
      background:linear-gradient(270deg,#cd6dfe 0%,#6d7efb 48.59%,#67faae 100%);
      -webkit-background-clip:text;
      -webkit-text-fill-color:transparent;
      background-clip:text;
      text-fill-color:transparent;
      font-family:PingFang SC;
      font-weight:600;
      font-size: 60px;
    }
    #index{
      .subtitle{
        letter-spacing:8px;
        margin-bottom: 40px;
        color:#fff;
      }
    }

    #ourGame{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height : 850px;
      .description{
        padding-right: 0 !important;
        margin-top: 0 !important;
        width : 400px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
      }

      .title{
        text-align: left !important;
        max-width: 400px;
        white-space: pre-wrap;
       // margin: 0 !important;
      }
      .title.en-US{
        font-size: 55px;
      }
      .subtitle{
        color:#fff;
        font-size: 24px;
        margin-bottom: 78px;
        max-width: 400px;
        white-space: pre-wrap;
      }
    /*  .cover{
        width : 564px;
        height : 680px;
      }*/
      .swiper-container{
        flex : 1;
      }
    }

    #electron,#sport{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height : 640px;
     .electronPig{
       width : 548px;
       height : 100%;
       flex : 1;
     }
      .innerBox{
        width : 350px;
        display: flex;
        align-items: flex-end;
        flex-direction: column;
      }
      .yishuzi{
        align-items: flex-end !important;
        margin-bottom: 12px;
        line-height: 84px;
      }
      .subtitle{
        color:#fff;
        font-size: 24px;
        line-height: 48px;
        text-align: right;
        margin : 0 !important;
      }
      .smallLogo{
        width : 92px;
        height : 26px;
        margin-top: 8px;
        margin-bottom: 36px;
        display: inline-block;
      }
    }
    #electron{
      .yishuzi{
        text-align: right;
      }
      .smallLogo{
        width : auto !important;
      }
    }
    #sport{
      /*height : auto;*/
      margin-top: 300px;
      margin-bottom: 230px;
      overflow: hidden;
      .yishuzi{
        background:linear-gradient(90deg,#b35afa 0%,#63b2ff 100%);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
        background-clip:text;
        text-fill-color:transparent;
        font-family:PingFang SC;
        font-weight:600;
        color:#ffffff;
        font-size:60px;
      }
      .innerBox{
        align-items: flex-start !important;
      }
    }

    .threeBox{
      display: flex;
      justify-content: space-between;
      width : $maxWidth;
      margin-top: 118px;
      >div{
        min-height: 159px;
        padding-top: 67px;
      }
      .pt{
        text-align: center !important;
        font-size: 14px;
        padding: 0 !important;
      }
      .pContent{
        color:#fff;
      }
      .d1{
        background: url("../../assets/anquan.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .d2{
        background: url("../../assets/jisu.png") no-repeat center center;
        background-size: 100% 100%;
      }
      .d3{
        background: url("../../assets/quanqiu.png") no-repeat center center;
        background-size: 100% 100%;
      }
    }


    #live{
     // margin-top: 230px;
      height : 721px;
      .yishuzi{
        width:400px;
        height:84px;
        background:linear-gradient(270deg,#cd6dfe 0%,#6d7efb 48.59%,#67faae 100%);
        -webkit-background-clip:text;
        -webkit-text-fill-color:transparent;
        background-clip:text;
        text-fill-color:transparent;
        font-family:PingFang SC;
        font-weight:600;
        color:#ffffff;
        font-size:60px;
        line-height:84px;
        margin: 0 auto;
      }
      .subtitle{
        color:#fff;
        font-size: 24px;
      //  line-height: 48px;
        text-align: right;
        margin : 0 !important;
      }
      .img-icon{
        margin-top: 25px;
      }

      .content{
        background: url("../../assets/live.png") no-repeat center center;
        background-size:cover;
        padding: 141px 0 0 285px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        height : 478px !important;
        >p{
          font-family:Arial Black;
          font-weight:900;
          color:#ffffff;
          font-size:72px;
          line-height:101px;
        }
        .newBtn{
          margin-left:110px;
          margin-top: 56px;
        }
      }
    }
    .pc-footer-wrapper{
      background: none !important;
      border-top: 0 !important;
    }
    .invite-btn{
      background: #111822;
    }
  }
  .popMain_btm{
    width: 50%;
    height: 55%;

    border-radius: 6px;
    z-index: 6;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    background-color: rgba(33, 33, 35, 1);
    .title{
      height : 60px;
      color:#fff;
      line-height: 60px;
      text-align: center;
      position: relative;
      &:after{
        content : '';
        height : 1px;
        background: #fff;
        display: block;
        position: absolute;
        width : 100%;
        left : 0;;
        bottom : 0;
        transform: scaleY(0.5);
      }
      font-size: 16px;
    }
    .closeBtn{
      z-index: 66;
    }
    .popContent{
      overflow-y: scroll;
      height: calc(100% - 60px);
      padding: 15px;
      color:#fff;
      text-align: left;
    }

  }

  
</style>

<style lang="scss">
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #606266;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-track {
    background-color: rgba(33, 33, 35, 1);
  }
  .popContent *{
    color:#fff !important;
  }

  .swiper-container{
    width: 100%;
    height: 100%;
    padding-top: 280px;
  }
  .swiper-slide {
    text-align: center;
    font-size: 18px;
   height : 265px;
   // transform: scale(1.2);
   // width : 250px;
   // background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
   // transform: scale(0.8);
  }
  .swiper-container{
    .swiper-slide-active,.swiper-slide-duplicate-active{
      transform: scale(1.2,1.15) translateY(-50px);
      position: relative;
      z-index: 2;
    }
  }

  .swiper-container2{
    width : 620px;
    height: 560px;
    overflow: hidden;
    padding-left: 50px;
    .swiper-slide{
      width: 520px;
      opacity: .4;
      //transform: scale(0.95);
    }
    .swiper-slide-active,.swiper-slide-duplicate-active{
     transform: scale(1.18);
      position: relative;
      opacity: 1;
      z-index: 2;
    }
  }


</style>
